import './DeparturesTools.scss';

import { useDispatch } from "react-redux";

import FileDownload from "@mui/icons-material/FileDownload";
import FilterAlt from "@mui/icons-material/FilterAlt";

import { openModal } from "../../../slices/modalSlice";
import { openDrawer } from "../../../slices/drawerSlice";

import { TextButton } from "../../../common-components/Buttons/Buttons";
import { IconButton } from "../../../common-components/Buttons/Buttons";
import { SearchBar } from "../../../common-components/SearchBar/SearchBar";

import ExportModal from "../../../export-modal/ExportModal";
import DeparturesFiltersTools from "../../DeparturesFilters/components/DeparturesFiltersTools/DeparturesFiltersTools";
import DeparturesFilters from "../../DeparturesFilters/DeparturesFilters";
import DeparturesFiltersFooter from "../../DeparturesFilters/components/DeparturesFiltersFooter/DeparturesFiltersFooter";

const DeparturesTools = () => {
    const dispatch = useDispatch();

    const handleOpen = () => {
        dispatch(openModal({closeable: true, content: <ExportModal/>}));
    }

    const handleOpenDrawer = () => {
        dispatch(openDrawer({content: <DeparturesFilters/>, tools: <DeparturesFiltersTools/>, footer: <DeparturesFiltersFooter/>}))
    }

    return (
        <div className={"departures-tools"}>
            <div className={"departures-tools_container"}>
                <div className={"departures-tools_left-section"}>
                    <SearchBar componentId={"departures"}/>
                </div>
                <div className={"departures-tools_desktop-buttons"}>
                    <TextButton Icon={FilterAlt} title={"Фильтры"} active={true} onClick={handleOpenDrawer}/>
                    <TextButton Icon={FileDownload} title={"Экспорт в Excel"} active={true} onClick={handleOpen}/>
                </div>
                <div className={"departures-tools_mobile-buttons"}>
                    <IconButton Icon={FilterAlt} onClick={handleOpenDrawer}/>
                </div>
            </div>
        </div>
    )
}

export default DeparturesTools;